import Vue from "vue";


import FormValidation from "./../components/formManagement/FormValidation"
import GCheckBox from "./../components/formManagement/formElements/GCheckBox"
import GDatePicker from "./../components/formManagement/formElements/GDatePicker"
import GInput from "./../components/formManagement/formElements/GInput"
import GTextEditor from "./../components/formManagement/formElements/GTextEditor"
import SelectV2 from "@/components/formManagement/formElements/SelectV2.vue";
import GTextArea from "./../components/formManagement/formElements/GTextArea"
import GAutoComplete from "./../components/formManagement/formElements/GAutoComplete"
import GUploader from "./../components/formManagement/formElements/GUploader";
import MultiSelectV2 from "@/components/formManagement/formElements/MultiSelectV2.vue";


Vue.component("bita-form", FormValidation);
Vue.component("bita-checkbox", GCheckBox);
Vue.component("bita-datepicker", GDatePicker);
Vue.component("bita-input", GInput);
Vue.component("bita-texteditor", GTextEditor);
Vue.component("bita-multiselect", MultiSelectV2);
Vue.component("bita-select", SelectV2);
Vue.component("bita-textarea", GTextArea);
Vue.component("bita-autocomplete", GAutoComplete);
Vue.component("bita-uploader", GUploader);